module.exports = __webpack_public_path__ + "assets/tacos-min.861de20f164115b02e0f4dbcb6e4db97.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/Aplifit/tacos-min.jpg
 ** module id = 393
 ** module chunks = 0
 **/